import { ChangeDetectorRef, Component, inject, OnInit } from '@angular/core';
import { BedienungsanleitungService } from '../../service/settings/bedienungsanleitung.service';
import { RedispatchFile } from '../../domain/model/redispatch-file';

@Component({
    selector: 'redispatch-dashboard-bedienungsanleitung',
    templateUrl: './dashboard-bedienungsanleitung.component.html',
    styleUrls: [
        './dashboard-bedienungsanleitung.component.scss',
    ],
    standalone: false,
})
export class DashboardBedienungsanleitungComponent implements OnInit {

    public file: RedispatchFile | null = null;

    private bedienungsanleitungService = inject(BedienungsanleitungService);
    private changeDetectorRef = inject(ChangeDetectorRef);

    constructor() {
    }

    ngOnInit(): void {
        this.bedienungsanleitungService.isAvailable().subscribe({
            next: (value) => {
                this.file = value;
                this.changeDetectorRef.markForCheck();
            },
            error: () => {
                this.file = null;
                this.changeDetectorRef.markForCheck();
            },
        });
    }

    public download() {
        if (this.fileExists) {
            this.bedienungsanleitungService.download();
        }
    }

    public get fileExists(): boolean {
        return this.file != null;
    }

}
